import { render, staticRenderFns } from "./CleanListTwoParams.vue?vue&type=template&id=67bab97f"
import script from "./CleanListTwoParams.vue?vue&type=script&lang=ts"
export * from "./CleanListTwoParams.vue?vue&type=script&lang=ts"
import style0 from "./CleanListTwoParams.vue?vue&type=style&index=0&id=67bab97f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports